var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17.011,
  height: 17.016,
  viewBox: "0 0 17.011 17.016"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-rocket",
  "data-name": "Icon awesome-rocket",
  d: "M15.789.6a.5.5,0,0,0-.381-.381A11.344,11.344,0,0,0,12.829,0C9.6,0,7.669,1.725,6.225,4H2.968a1.5,1.5,0,0,0-1.34.828L.083,7.917A.75.75,0,0,0,.755,9H4l-.7.7a1,1,0,0,0,0,1.414l1.591,1.591a1,1,0,0,0,1.415,0l.7-.7v3.246a.75.75,0,0,0,1.085.672l3.085-1.544A1.5,1.5,0,0,0,12,13.041V9.777c2.269-1.447,4-3.388,4-6.6A11.088,11.088,0,0,0,15.789.6ZM12.005,5.251A1.25,1.25,0,1,1,13.256,4a1.25,1.25,0,0,1-1.25,1.25Z",
  transform: "translate(0.507 0.5)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
})));
export default __webpack_public_path__ + "static/media/escalations.0290e3d5.svg";
export { SvgComponent as ReactComponent };